import { Typography } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useTheme } from "../../../contexts/ThemeContext";

const { Text } = Typography;

/**
 * Instruções da seção: três passos sempre visíveis e as regras de preenchimento sob demanda.
 * Texto neutro, sem banners: é referência, não alerta.
 */
const HowItWorks = ({ capabilities, rulesOpen = false, onToggleRules }) => {
  const { theme } = useTheme();
  const { supportsSales, supportsDepartments, cadastrosTexto } = capabilities;

  const steps = [
    {
      title: "Baixe o modelo",
      text: `Ele já traz as listas de ${cadastrosTexto} cadastrados no ERP.`,
    },
    {
      title: "Preencha",
      text: supportsSales
        ? "Uma linha por título (aba Títulos) e uma linha por venda (aba Vendas)."
        : "Uma linha por título.",
    },
    {
      title: "Envie",
      text: "A planilha substitui a anterior e é aplicada automaticamente nos relatórios.",
    },
  ];

  const rules = [
    "Cada envio substitui todos os lançamentos enviados anteriormente. Mantenha na planilha tudo o que deve continuar valendo.",
    "Descrição é o que identifica o lançamento.",
    "Pessoa é o fornecedor (títulos a pagar) ou o cliente (títulos a receber). Vazia, é lançada como Não definido.",
    "A natureza (Pagar ou Receber) vem da categoria do ERP. A coluna Natureza só é considerada para categorias novas, ou quando a categoria existe no ERP como Pagar e como Receber.",
    "Com Data Pagto preenchida, o título é considerado pago.",
    supportsDepartments
      ? "Departamento vazio é lançado como Não definido."
      : "Este ERP não tem departamentos: a planilha não traz essa coluna.",
    supportsSales
      ? "Vendas: Descrição e Cliente são opcionais; sem descrição, a venda é descrita pelo Produto."
      : "Este ERP aceita apenas títulos.",
    "Todos os campos podem ser digitados; as listas nas células são apenas sugestões do cadastro do ERP.",
    `Nomes de ${cadastrosTexto} que não existirem no cadastro são criados no D4C (não no ERP). Categorias novas precisam ser vinculadas na configuração da DRE.`,
  ];

  return (
    <div>
      <ol style={{ listStyle: "none", margin: 0, padding: 0, display: "flex", flexDirection: "column", gap: 14 }}>
        {steps.map((step, index) => (
          <li key={step.title} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
            <span
              style={{
                flex: "0 0 24px",
                height: 24,
                borderRadius: "50%",
                border: `1px solid ${theme.border}`,
                color: theme.textSecondary,
                fontSize: 12,
                fontWeight: 600,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {index + 1}
            </span>
            <div style={{ minWidth: 0 }}>
              <Text strong style={{ display: "block", fontSize: 13, color: theme.textPrimary }}>
                {step.title}
              </Text>
              <Text style={{ fontSize: 13, color: theme.textSecondary }}>{step.text}</Text>
            </div>
          </li>
        ))}
      </ol>

      <button
        type="button"
        onClick={onToggleRules}
        aria-expanded={rulesOpen}
        style={{
          marginTop: 16,
          padding: 0,
          border: 0,
          background: "none",
          cursor: "pointer",
          color: theme.textSecondary,
          fontSize: 13,
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        Regras de preenchimento
        {rulesOpen ? <UpOutlined style={{ fontSize: 10 }} /> : <DownOutlined style={{ fontSize: 10 }} />}
      </button>

      {rulesOpen && (
        <ul style={{ margin: "10px 0 0", paddingLeft: 18, display: "flex", flexDirection: "column", gap: 6 }}>
          {rules.map((rule) => (
            <li key={rule} style={{ fontSize: 13, lineHeight: "20px", color: theme.textSecondary }}>
              {rule}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default HowItWorks;
